import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=male&exp=web_fallback_on_payment_male_eu~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_eu/web_fallback_on_payment_male_eu__male'),
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-male-walking&exp=web_fallback_on_payment_male_eu~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_eu/web_fallback_on_payment_male_eu__male_walking'),
			},
		},
		'activity-male-tai-chi-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-male-tai-chi-yoga&exp=web_fallback_on_payment_male_eu~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_eu/web_fallback_on_payment_male_eu__male_tai_chi_yoga'),
			},
		},
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-male-chair-workouts&exp=web_fallback_on_payment_male_eu~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_fallback_on_payment_male_eu/web_fallback_on_payment_male_eu__male_chair_workouts'),
			},
		},
	},
]

export default config
